import { render, staticRenderFns } from "./hotGoods.vue?vue&type=template&id=64d9a0b6&scoped=true&"
import script from "./hotGoods.vue?vue&type=script&lang=js&"
export * from "./hotGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d9a0b6",
  null
  
)

export default component.exports